import { useEffect, useRef } from "react";
import { get } from "utils/WebService";

const INTERVALO_MS = 15000;

/**
 * Modelos alterados em outra tela ou por outro usuário: consulta a versão dos modelos (o backend muda a cada salvar ou
 * excluir) a cada 15 s com a janela visível, e na hora ao voltar para ela; quando muda, chama
 * aoMudar({ versao, modeloId, nome, acao, quem, quando }). Antes a mudança só aparecia com F5 ou reabrindo a tela.
 * marcarVisto(versao) guarda a versão de uma alteração feita nesta tela, para ela não voltar como aviso.
 */
export default function useVersaoModelos(aoMudar) {
    const versao = useRef(null);
    const callback = useRef(aoMudar);
    callback.current = aoMudar;

    useEffect(() => {
        let ativo = true;
        const consultar = (avisar) => get("/mala-direta/modelos/versao")
            .then((r) => {
                if (!ativo || r?.versao == null) return;
                const anterior = versao.current;
                versao.current = r.versao;
                if (avisar && anterior != null && anterior !== r.versao) callback.current(r);
            })
            .catch(() => null);
        consultar(false);
        const verificar = () => {
            if (document.visibilityState === "visible") consultar(true);
        };
        const t = setInterval(verificar, INTERVALO_MS);
        document.addEventListener("visibilitychange", verificar);
        return () => {
            ativo = false;
            clearInterval(t);
            document.removeEventListener("visibilitychange", verificar);
        };
    }, []);

    return {
        marcarVisto: (novaVersao) => {
            if (novaVersao != null) versao.current = novaVersao;
        },
    };
}
